import { configureStore } from '@reduxjs/toolkit';
import contentSlice from './slices/contentSlice';

const store = configureStore({ reducer: { content: contentSlice.reducer } });

export default store;
